import React, {useState} from 'react';


const titleStyle = {
    display:"flex",
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};
const mainStyle = {
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    font: "20px",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};


const Register = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');


    const handleLogin = async () =>{
 
    };
    
    return(
        <div>
            <div>
                <h1 style={titleStyle}>Register a New User</h1>
            </div>
            <div style={mainStyle}>
                <label htmlFor='username'>Username:</label><br/>
                <input type="text" placeholder='Username' value={username} onChange={(e) => setUsername(e.target.value)}/><br/><br/>
                <label htmlFor="password">Password:</label><br/>
                <input type="password" placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value)} /><br/><br/>
                <button onClick={handleLogin}>Register User</button><br/><br/>
            </div>
            <div>
                {message}
            </div>
        
        </div>
        
    )

}

export default Register;